import { ApiBase } from '@/api/api'
import { makePutRequest } from '@/api/fetchCalls'

export type UpdateUpdateLockedMeasuresQuestionsByFormIdProps = {
  formId: string
  data: { questions: (number | string)[] }
}
export const updateLockedMeasuresQuestionsByFormId = async ({
  formId,
  data,
}: UpdateUpdateLockedMeasuresQuestionsByFormIdProps): Promise<void> => {
  return makePutRequest(ApiBase + `/forms/${formId}/measures`, {
    body: JSON.stringify(data),
  })
}
